<ion-header mode="ios">
  <ion-toolbar mode="ios">
    <ion-buttons slot="start">
      <ion-button ionBackButton (click)="onDismiss()">
        <ion-icon src="/assets/icon/back-icon-dark.svg"></ion-icon>
      </ion-button>
    </ion-buttons>

    <ion-title> Select Language </ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  @if ({
    languageId: languageId$ | async,
    supportedLanguages: supportedLanguages$ | async,
    loading: loading$ | async
    }; as vm) {
    <ion-item
      lines="none"
      >
      @if (vm.loading === true) {
        <div class="spinner-container">
          <ion-spinner name="crescent"></ion-spinner>
        </div>
      } @else {
        @if (vm.supportedLanguages.length === 0) {
          <ion-text>Couldn't load languages, please try again later.</ion-text>
        }
        @if (vm.supportedLanguages.length > 0) {
          <ion-radio-group #languageRadioGroup value="vm.languageId">
            @for (language of vm.supportedLanguages; track language) {
              <ion-item>
                <ion-label>{{ language.name }}</ion-label>
                <ion-radio slot="end" [value]="language.id"></ion-radio>
              </ion-item>
            }
          </ion-radio-group>
        }
      }
    </ion-item>
  }
</ion-content>
<ion-footer mode="ios">
  <ion-button mode="md" [disabled]="!itemSelected" class="submitButton" color="secondary" (click)="onOk()"
    >Apply
  </ion-button>
</ion-footer>
